import {
  faFileAlt,
  faPencilAlt,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { B2Button } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import { FC, createRef, useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import { getBlockTypes } from "src/store/slices/floor.slice";
import * as yup from "yup";
import {
  getAllContactRole,
  getAllSites,
} from "../../../../../core/api/services/location-site.service";
import ModalComponent from "../../../../../core/components/modal/modal.component";
import TableComponent from "../../../../../core/components/table/table.component";
import HasPermission from "../../../../../core/guards/has-permission";
import SkeletonComponent from "../../../../../shared/custom-spinner/skeleton.component";
import FormBuilderComponent, {
  FormConfig,
} from "../../../../../shared/form-builder/form-builder.component";
import {
  addBlock,
  addBlockContacts,
  deleteBlock,
  editBlock,
  getBlockContacts,
  getBlockDetailsByCode,
  getLocationBlocks,
  setBlockToSublocation,
} from "../../../../../store/slices/location-block.slice";
import SearchBarComponent from "../../search-bar/search-bar.component";
// import BlockDetailComponent from "./block-detail.component";
import DynamicFormComponent from "src/shared/dynamic-form/dynamic-form-builder.component";
import {
  addField,
  closeField,
  setValues,
} from "src/shared/dynamic-form/dynamic-form-util";
import { isValidPhoneNumber } from "src/shared/helpers/phone-no-validity";
import "../../../admin.scss";

interface BlockTableComponentProps {
  columns: any;
  data: any[];
  totalNumberOfRecords: number;
  pageSize: number;
  current: number;
  onChangePage: any;
  onChangeSort: any;
  onRefetchData: () => void;
  isLoading: boolean;
  onSearch: (val: string) => void;
}

const BlockTableComponent: FC<BlockTableComponentProps> = ({
  columns,
  data,
  totalNumberOfRecords,
  pageSize,
  current,
  onChangePage,
  onChangeSort,
  onRefetchData,
  isLoading,
  onSearch,
}) => {
  const formRef = createRef();
  const formRefForContacts = createRef();
  const blockDetailsModalRef: any = createRef();
  const locationModalRef: any = createRef();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isDetails, setIsDetails] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [selectedCodeToDeleteOrEdit, setSelectedCodeToDeleteOrEdit] =
    useState<number>(0);
  const [siteOptions, setSiteOptions] = useState<any>([]);

  const [contactRoleOptions, setContactRoleOptions] = useState<any>([]);

  // const [selectedBlock, setSelectedBlock] = useState<any>(null);

  const [initialValues, setInitialValues] = useState<any>({
    blockCode: "",
    blockName: "",
    // blockTypeId: "",
    prefix: "",
    siteCode: "",
    // noOfFloor: "",
    description: "",
    street: "",
  });

  const initialValuesForContactsObjects = {
    motionTime: [
      {
        id: 0,
        phoneNo: "",
        contactRoleId: 0,
      },
    ],
  };

  const [initialValuesForContacts, setInitialValuesForContacts] = useState<any>(
    initialValuesForContactsObjects
  );

  const [activeTab, setActiveTab] = useState("edit block");

  const dispatch = useDispatch();

  const blockDetails = useSelector((state: any) => {
    return state.locationBlock.blockDetails;
  });

  const isLoadingBlockDetails = useSelector((state: any) => {
    return state.locationBlock.isLoadingBlockDetails;
  });

  // const blockTypes = useSelector((state: any) => state.floor?.blockTypes);

  const { data: siteResponse, isLoading: isLoadingLocationSites } = useQuery({
    queryKey: ["getAllSites"],
    queryFn: ({ signal }) => getAllSites(signal),
  });

  const { data: contactRoleResponse } =
    useQuery({
      queryKey: ["getAllContactRole"],
      queryFn: ({ signal }) => getAllContactRole(signal),
    });

  useEffect(() => {
    const sites = siteResponse?.data?.map((site: any) => ({
      label: site?.name,
      value: site?.siteCode,
    }));

    setSiteOptions(sites);
  }, [siteResponse]);

  useEffect(() => {
    // console.log("contactRoleResponse", contactRoleResponse);
    const contacts = contactRoleResponse?.data?.map((contact: any) => ({
      label: contact?.name,
      value: contact?.id,
    }));

    setContactRoleOptions(contacts);
  }, [contactRoleResponse]);

  // useEffect(() => {
  //   const blockTypeOptions = blockTypes?.data?.map((blockLocation: any) => ({
  //     label: blockLocation?.name,
  //     value: blockLocation?.id,
  //   }));

  //   setBlockTypeOptions(blockTypeOptions);
  // }, [blockTypes]);

  // useEffect(() => {
  //   dispatch(getBlockTypes());
  // }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsDetails(false);
    setIsEdit(false);
    setIsDelete(false);
    setActiveTab("edit block");
    dispatch(setBlockToSublocation([]));

    setInitialValues({
      blockCode: "",
      blockName: "",
      // blockTypeId: "",
      prefix: "",
      siteCode: "",
      phoneNo: [],
      // noOfFloor: "",
      description: "",
      street: "",
    });

    setBlockContactsValues(initialValuesForContactsObjects);
  };

  const AddAction = () => {
    handleCloseModal();
    setIsModalOpen(true);
  };

  const detailsAction = (blockCode: any) => {
    // setSelectedBlock(blockCode);
    setIsDetails(true);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(false);

    dispatch(getBlockDetailsByCode({ blockCode }))
      .then(() => {
        dispatch(getBlockContacts({ blockCode }));
      })
      .catch((error: any) => {
        console.log("Error in api call: ", error);
      });
  };

  const editAction = (blockCode: any) => {
    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(true);
    setIsDelete(false);

    dispatch(getBlockDetailsByCode({ blockCode }))
      .then(() => {
        dispatch(getBlockContacts({ blockCode }));
      })
      .catch((error: any) => {
        console.log("Error in api call: ", error);
      });

    setSelectedCodeToDeleteOrEdit(blockCode);
  };

  const deleteAction = (blockCode: any) => {
    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(true);

    setSelectedCodeToDeleteOrEdit(blockCode);
  };

  const handleDelete = () => {
    dispatch(deleteBlock({ blockCode: selectedCodeToDeleteOrEdit })).then(
      () => {
        onRefetchData();
        handleCloseModal();
      }
    );
  };

  useEffect(() => {
    if (!blockDetails || !Object.keys(blockDetails).length) return;

    setInitialValues({
      blockCode: blockDetails?.blockCode || "",
      blockName: blockDetails?.blockName || "",
      // blockTypeId: blockDetails?.blockTypeId || "",
      prefix: blockDetails?.prefix || "",
      siteCode: blockDetails?.siteCode || "",
      description: blockDetails?.description || "",
      street: blockDetails?.street || "",
    });

    // Handle multiple contacts from motionTime
    const newValuesForContactsObjects = blockDetails?.contactDetail?.length
      ? {
        motionTime: blockDetails.contactDetail.map(
          (item: { id: number; phoneNo: string; contactRoleId: number }) => ({
            id: item.id || 0,
            phoneNo: item.phoneNo?.startsWith("+65")
              ? item.phoneNo.substring(3)
              : item.phoneNo || "",
            contactRoleId: item.contactRoleId || 0,
          })
        ),
      }
      : { motionTime: [{ id: 0, phoneNo: "", contactRoleId: 0 }] };

    setBlockContactsValues(newValuesForContactsObjects);
  }, [blockDetails]);

  const onSubmit = () => {
    const form: any = formRef.current;
    if (form) {
      form.handleSubmit();
      const { blockName, siteCode, street, blockCode, description } =
        form.values;

      if (!blockName || !siteCode || !street || !blockCode) {
        return;
      }

      // check if blockCode is 6 digit number
      // check if blockName and street are less than 50 characters
      // check if description is less than 200 characters
      if (
        !/^\d{6}$/.test(blockCode) ||
        blockName?.length > 50 ||
        street?.length > 50 ||
        description?.length > 200
      ) {
        return;
      }

      if (isEdit) {
        const formValues = form.values;

        const payload = {
          ...formValues,
          // blockTypeId: Number(blockTypeId),
        };

        dispatch(
          editBlock({ payload, blockCode: selectedCodeToDeleteOrEdit })
        ).then(() => {
          handleCloseModal();
          onRefetchData();
        });
      } else {
        dispatch(addBlock({ payload: form.values })).then(() => {
          handleCloseModal();
          onRefetchData();
        });
      }
    }
  };

  const isValidSinglePhoneNumber = (phoneNo: string) => {
    return phoneNo && phoneNo.length > 0 && isValidPhoneNumber(phoneNo);
  };

  const isContactRoleIdValid = (contactRoleId: any) => {
    // Check if contactRoleId is a valid number
    if (!Number.isInteger(Number(contactRoleId))) {
      return false;
    }

    // Convert to number for comparison
    const roleId = Number(contactRoleId);

    // Check if contactRoleId exists in contactRoleOptions
    const roleExists = contactRoleOptions?.some(
      (option: any) => option.value === roleId
    );

    return roleExists;
  };

  const checkForDuplicatePhoneNumbers = (motionTimeEntries: any[]) => {
    if (!motionTimeEntries || motionTimeEntries.length === 0) {
      return true;
    }

    // Get all phone numbers from entries (filter out empty ones)
    const phoneNumbers = motionTimeEntries
      .map((entry: any) => entry.phoneNo?.trim())
      .filter((phoneNo: string) => phoneNo && phoneNo.length > 0);

    // Check if any phone number appears more than once
    const phoneNumberCount = new Map();

    for (const phoneNo of phoneNumbers) {
      const count = phoneNumberCount.get(phoneNo) || 0;
      phoneNumberCount.set(phoneNo, count + 1);

      // If we find a duplicate, return false immediately
      if (count >= 1) {
        return false;
      }
    }

    return true;
  };

  const onSubmiBlockConacts = () => {
    const form: any = formRefForContacts.current;
    if (form) {
      form.handleSubmit();
      // Get all motionTime entries
      const motionTimeEntries = form.values.motionTime || [];

      // Validate all entries
      const isValid = motionTimeEntries.every((entry: any) => {
        const { phoneNo, contactRoleId } = entry;
        return (
          phoneNo &&
          isValidSinglePhoneNumber(phoneNo) &&
          isContactRoleIdValid(contactRoleId)
        );
      });

      if (!isValid) {
        console.error("Validation failed for one or more contacts");
        return;
      }

      // Check for duplicate phone numbers
      const hasNoDuplicates = checkForDuplicatePhoneNumbers(motionTimeEntries);

      if (!hasNoDuplicates) {
        console.error("Duplicate phone numbers found");
        return;
      }

      // Create payloads for all valid entries
      const payload = {
        blockCode: selectedCodeToDeleteOrEdit,
        contactDetail: motionTimeEntries.map((entry: any) => ({
          id: entry.id || 0, // Use existing id or default to 0 if not provided
          phoneNo: "+65" + entry.phoneNo,
          contactRoleId: Number(entry.contactRoleId) || 0,
        })),
      };

      // Dispatch action for all payloads
      if (isEdit) {
        dispatch(addBlockContacts({ payload })).then(() => {
          handleCloseModal();
          onRefetchData();
        });
      } else {
        addBlockContacts({ payload }).then(() => {
          handleCloseModal();
          onRefetchData();
        });
      }
    }
  };

  const handleTabSelect = (eventKey: any) => {
    setActiveTab(eventKey);
  };

  const onSubmitDetails = () => {
    blockDetailsModalRef.current?.onsubmit();
  };

  const onSubmitLocation = () => {
    locationModalRef.current?.onSubmit();
  };

  const modalActionConfig: any = isDetails
    ? []
    : isDelete
      ? [
        {
          label: "Yes",
          event: handleDelete,
          variant: "primary",
        },
      ]
      : [
        {
          label: "Save",
          event:
            activeTab === "edit block"
              ? onSubmit
              : activeTab === "edit floor"
                ? onSubmitDetails
                : activeTab === "block contact"
                  ? onSubmiBlockConacts
                  : onSubmitLocation,
          variant: "primary",
        },
      ];

  const actionConfig: any = [
    {
      label: "Edit",
      actionProperty: "blockCode",
      event: editAction,
      variant: "secondary",
      className: "mx-2 my-1",
      moduleName: "Block",
      actionName: "Edit-Block",
      icon: faPencilAlt,
    },
    {
      label: "View",
      actionProperty: "blockCode",
      event: detailsAction,
      variant: "info",
      className: "mx-2 my-1",
      moduleName: "Block",
      actionName: "View-Block",
      icon: faFileAlt,
    },
    {
      label: "Delete",
      actionProperty: "blockCode",
      event: deleteAction,
      variant: "danger",
      className: "mx-2 my-1",
      moduleName: "Block",
      actionName: "Delete-Block",
      icon: faTrashAlt,
    },
  ];

  const emptyConfig = {
    title: "No Block Found",
    description: "",
  };

  const formConfig: FormConfig = {
    controls: [
      {
        name: "blockCode",
        label: "Block Code",
        placeholder: "310480",
        type: "text",
        required: !isDetails,
        readOnly: isDetails || isEdit,
        disabled: isDetails || isEdit,
      },
      {
        name: "blockName",
        label: "Block Name",
        placeholder: "480",
        type: "text",
        required: !isDetails,
        readOnly: isDetails,
        disabled: isDetails,
      },
      /* {
        name: "blockTypeId",
        label: "Block Type",
        placeholder: "Block Type",
        type: "select",
        options: blockTypeOptions,
        required: true,
        readOnly: isDetails || isEdit,
        disabled: isDetails || isEdit,
      }, */
      {
        name: "siteCode",
        label: "Site",
        placeholder: "Select Site",
        type: "searchable-select",
        options: siteOptions,
        required: !isDetails,
        readOnly: isDetails || isEdit,
        disabled: isDetails || isEdit,
      },
      {
        name: "street",
        label: "Street",
        placeholder: "Lor 6 Toa Payoh",
        type: "textarea",
        required: !isDetails,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "description",
        label: "Description",
        placeholder: "Something...",
        type: "textarea",
        required: false,
        readOnly: isDetails,
        disabled: isDetails,
      },
    ],
  };

  const formConfigForContactsObject = {
    controls: [
      {
        fieldArray: {
          fieldArrayConfig: {
            fieldArrayName: "motionTime",
          },
          fieldArrayControls: [
            {
              controlGroup: [
                {
                  name: "contactRoleId",
                  label: "Contact",
                  placeholder: "Select Contact",
                  type: "select",
                  options: contactRoleOptions,
                  required: false,
                  readOnly: isDetails,
                  disabled: isDetails,
                },
                {
                  name: "phoneNo",
                  label: "Mobile Number",
                  placeholder: "Enter a mobile number (XXXX XXXX)",
                  type: "tel",
                  prefix: "+65",
                  pattern: "[+65]{3}[0-9]{4}[0-9]{4}",
                  required: false,
                  readOnly: isDetails,
                  disabled: isDetails,
                  inputMode: "numeric",
                  maxLength: 8,
                },
              ],
            },
          ],
        },
      },
    ],
  };

  const [formConfigForContacts, setFormConfigForContacts] = useState(
    formConfigForContactsObject
  );

  const validationSchemaForContacts = yup.object().shape({
    motionTime: yup.array().of(
      yup.object().shape({
        contactRoleId: yup
          .string()
          .test("is-valid-contact-role", "Please select a contact", (value) =>
            isContactRoleIdValid(value)
          ),
        phoneNo: yup
          .string()
          .test(
            "both-fields-or-none",
            "Please provide a phone number or remove the entry",
            function (value, context) {
              const { phoneNo } = context.parent;
              return !!phoneNo;
            }
          )
          .test(
            "is-valid-phone",
            "Invalid phone number format",
            (value) => !value || isValidPhoneNumber(value)
          )
          .test(
            "no-duplicate-phone",
            "This phone number is already used",
            function (value, context) {
              if (!value) return true; // Skip validation for empty values

              // Get the current index from the path
              const currentIndex = /\[(\d+)\]/.exec(context.path)?.[1];
              // console.log("currentIndex", currentIndex);

              // Get all motionTime entries from the root
              const motionTimeEntries = context.from?.[1]?.value?.motionTime || [];

              // Check if current phone number exists at a different index
              const duplicateIndex = motionTimeEntries.findIndex(
                (entry: any, index: number) =>
                  entry.phoneNo?.trim() === value.trim() &&
                  index !== Number(currentIndex)
              );

              return duplicateIndex === -1; // Return true if no duplicate found
            }
          ),
      })
    ),
  });

  const validationSchema = yup.object().shape({
    blockCode: yup
      .string()
      .required("Block Code is required")
      .matches(/^\d{6}$/, "Block Code must be a 6-digit number"),
    blockName: yup
      .string()
      .required("Block Name is required")
      .max(50, "Block Name must be at most 50 characters"),
    siteCode: yup.string().required("Site is required"),
    street: yup
      .string()
      .required("Street is required")
      .max(50, "Street must be at most 50 characters"),
    description: yup
      .string()
      .max(200, "Description must be at most 200 characters"),
  });

  const setBlockContactsValues = (details: any) => {
    setValues({
      details: details,
      formGroupObject: formConfigForContactsObject,
      setFormGroupInitialValues: setInitialValuesForContacts,
      setFormConfig: setFormConfigForContacts,
    });
  };

  const onClickAdd = (fieldArrayName?: any) => {
    addField({
      fieldArrayName,
      formRef: formRefForContacts,
      FormGroupInitialValues: initialValuesForContacts,
      FormConfig: formConfigForContacts,
      setFormGroupInitialValues: setInitialValuesForContacts,
      setFormConfig: setFormConfigForContacts,
      FormInitialValueObject: initialValuesForContactsObjects.motionTime[0],
      FormConfigObject: formConfigForContactsObject.controls,
    });
  };

  const onClickClose = (deletionIdx: any, fieldArrayName: any) => {
    closeField({
      deletionIdx,
      fieldArrayName,
      formRef: formRefForContacts,
      FormGroupInitialValues: initialValuesForContacts,
      FormConfig: formConfigForContacts,
      setFormGroupInitialValues: setInitialValuesForContacts,
      setFormConfig: setFormConfigForContacts,
    });
  };

  return (
    <div>
      <div>
        <div className="d-flex gap-3 justify-content-end table-generic-action table-toolbar">
          <SearchBarComponent
            placeholder="Search Block"
            methodToDispatch={getLocationBlocks}
            getSearch={onSearch}
          />
          <HasPermission
            moduleName="Block"
            actionName="Add-Block"
            isRoute={false}
          >
            <B2Button
              className="icon-text-btn"
              variant="primary"
              onClick={() => AddAction()}
            >
              Add New Block
            </B2Button>
          </HasPermission>
        </div>
        <div className="my-3">
          <TableComponent
            tableHeaders={columns}
            emptyConfig={emptyConfig}
            data={data}
            totalNumberOfRecords={totalNumberOfRecords}
            pageSize={pageSize}
            current={current}
            onChangePage={onChangePage}
            actionConfig={actionConfig}
            onChangeSort={onChangeSort}
            isLoadingData={isLoading}
          />
        </div>
      </div>

      {/* modals */}

      {isModalOpen && (
        <ModalComponent
          isConformationModal={isDelete}
          showModal={isModalOpen}
          handleClose={handleCloseModal}
          size={isDelete ? "lg" : isDetails || isEdit ? "xl" : "lg"}
          headerTitle={
            isDetails
              ? "Block Details"
              : isEdit
                ? "Edit Block"
                : isDelete
                  ? "Delete Block"
                  : "Add New Block"
          }
          actionConfig={modalActionConfig}
        >
          {isDelete ? (
            <h5 className="text-center">
              Are you sure to <b className="text-danger">Delete</b>?
            </h5>
          ) : isDetails ? (
            <SkeletonComponent
              wrapperHeight="400px"
              skeletonHeight="50px"
              isLoading={isLoadingBlockDetails || isLoadingLocationSites}
              count={7}
            >
              <Tabs
                defaultActiveKey="block details"
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={handleTabSelect}
              >
                <Tab eventKey="block details" title="Block Details">
                  <FormBuilderComponent
                    formRef={formRef}
                    initialValues={initialValues}
                    validation={validationSchema}
                    formConfig={formConfig}
                  />
                </Tab>
                <Tab eventKey="block contact details" title="Block Contacts">
                  <DynamicFormComponent
                    formRef={formRefForContacts}
                    initialValues={initialValuesForContacts}
                    formConfig={formConfigForContacts}
                    isSecurityMonitoring={true}
                    validation={validationSchemaForContacts}
                    formStyle={{ backgroundColor: "white" }}
                  />
                </Tab>
              </Tabs>
            </SkeletonComponent>
          ) : isEdit ? (
            <SkeletonComponent
              wrapperHeight="400px"
              skeletonHeight="50px"
              isLoading={isLoadingBlockDetails || isLoadingLocationSites}
              count={7}
            >
              <Tabs
                defaultActiveKey="edit block"
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={handleTabSelect}
              >
                <Tab eventKey="edit block" title="Edit Block">
                  <FormBuilderComponent
                    formRef={formRef}
                    initialValues={initialValues}
                    validation={validationSchema}
                    formConfig={formConfig}
                  />
                </Tab>
                <Tab eventKey="block contact" title="Block Contacts">
                  <DynamicFormComponent
                    formRef={formRefForContacts}
                    initialValues={initialValuesForContacts}
                    formConfig={formConfigForContacts}
                    isSecurityMonitoring={true}
                    onClickAddBtn={{ index: 0, func: onClickAdd }}
                    onClickCloseBtn={{ index: 0, func: onClickClose }}
                    validation={validationSchemaForContacts}
                    formStyle={{ backgroundColor: "white" }}
                    addButtonTitle="Add Contact"
                    onClickCloseFromStart={true}
                  />
                </Tab>
              </Tabs>
            </SkeletonComponent>
          ) : (
            <SkeletonComponent
              wrapperHeight="400px"
              skeletonHeight="50px"
              isLoading={isLoadingLocationSites}
              count={7}
            >
              <FormBuilderComponent
                formRef={formRef}
                initialValues={initialValues}
                validation={validationSchema}
                formConfig={formConfig}
              />
            </SkeletonComponent>
          )}
        </ModalComponent>
      )}
    </div>
  );
};

export default BlockTableComponent;
